export default __webpack_public_path__ + "static/media/globe-logo.f47297ee.png";